import { FunctionComponent, useEffect, useState } from 'react'
import DashboardItem from '../DashboardItem'
import { getUsersToRemove } from 'Frontend/scripts/services/users.service'
import DeleteUser from './DeleteUser'
import { useTranslation } from 'react-i18next'
import { IMembersSearchResults, IMembersSearchResultsItem } from 'Frontend/scripts/models/members.model'
import Paging from 'Features/Paging/paging'
import { Form } from 'react-bootstrap'

const HandleDeleteUsers: FunctionComponent = () => {
  const [users, setUsers] = useState<IMembersSearchResults>()
  const [filter, setFilter] = useState<string>()
  const { t } = useTranslation()

  const [activePage, setActivePage] = useState<number>(1)

  const changePage = (activePage: number) => {
    setActivePage(activePage)
    getAllUsers(activePage)
  }

  const getAllUsers = (newActivePage?: number) => {
    if (filter != null) {
      getUsersToRemove(newActivePage ? newActivePage : activePage, filter).then((users) => {
        setUsers(users)
      })
    } else {
      getUsersToRemove(newActivePage ? newActivePage : activePage).then((users) => {
        setUsers(users)
      })
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getAllUsers()
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [filter])
  return (
    <DashboardItem heading={t('dashboard.delete-users.delete-users')}>
      <div>
        <Form.Group className="mb-3">
          <Form.Label htmlFor="user-filter">{t('dashboard.delete-users.search-user')}</Form.Label>
          <Form.Control
            id="user-filter"
            type="text"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFilter(e.target.value)
              setActivePage(1)
            }}
          />
        </Form.Group>
        <ul className="list-unstyled d-flex flex-column">
          {users?.items.map((user: IMembersSearchResultsItem) => (
            <DeleteUser key={`user${user.id}`} user={user} callback={() => getAllUsers()} />
          ))}
        </ul>
      </div>
      {users?.totalPages && users?.totalPages > 1 && (
        <Paging
          noOfPages={users?.totalPages as number}
          activePage={activePage}
          callback={(activePage) => {
            changePage(activePage)
          }}
        />
      )}
    </DashboardItem>
  )
}

export default HandleDeleteUsers
